import React from 'react';

import { useTheme, useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';

const Hidden = (props) => {
    const { children } = props;
    const theme = useTheme();

    const matches = {
        xsUp: useMediaQuery(theme.breakpoints.up('xs')),
        smUp: useMediaQuery(theme.breakpoints.up('sm')),
        mdUp: useMediaQuery(theme.breakpoints.up('md')),
        lgUp: useMediaQuery(theme.breakpoints.up('lg')),
        xlUp: useMediaQuery(theme.breakpoints.up('xl')),
        xsDown: useMediaQuery(theme.breakpoints.down('xs')),
        smDown: useMediaQuery(theme.breakpoints.down('sm')),
        mdDown: useMediaQuery(theme.breakpoints.down('md')),
        lgDown: useMediaQuery(theme.breakpoints.down('lg')),
        xlDown: useMediaQuery(theme.breakpoints.down('xl')),
    };

    // Check if any of the given props matches the condition to hide
    const shouldHide = Object.entries(props).some(
        ([key, value]) => value && matches[key] && key !== 'children'
    );

    if (shouldHide) return null;

    return <>{children}</>;
};

Hidden.propTypes = {
    children: PropTypes.node,
};

export default Hidden;
